<template>
  <v-card width="400px" style="display: inline-block">
    <v-container :style="{ height: height }">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          {{ $t("loadingInProgress") | capitalize }} <br />
          {{ $t("pleaseWait") | capitalize }}
        </v-col>
        <v-col cols="6" class="text-center">
          <v-progress-circular :size="70" color="primary" indeterminate />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LoadingInProgress extends Vue {
  @Prop({ default: "400px" })
  height!: string;
}
</script>

<style scoped></style>
